export const SHOW_CV = process.env.REACT_APP_SHOW_CV?.toLowerCase() === "true";